import React, { useState, useEffect } from "react";
import api from '../api';
import * as XLSX from "xlsx";
import '../styles/attCadastral.scss';

const AttCadastral = () => {
    const [modificacoes, setModificacoes] = useState([]);
    const [modificacoesRealizadas, setModificacoesRealizadas] = useState([]);

    useEffect(() => {
        const fetchModificacoes = async () => {
            try {
                const response = await api.get('/log-att-cadastral');
                const lastTwoModificacoes = response.data.slice(-2);
                setModificacoes(lastTwoModificacoes);
                getModificacoesRealizadas(lastTwoModificacoes);
            } catch (error) {
                console.error('Erro ao buscar modificações:', error);
            }
        };

        fetchModificacoes();
    }, []);

    const getModificacoesRealizadas = (modificacoes) => {
        if (modificacoes.length < 2) return;

        const [sobrescricao, atualizacao] = modificacoes;
        const modificacoesFeitas = [];

        for (const key in atualizacao) {
            if (atualizacao[key] !== sobrescricao[key]) {
                modificacoesFeitas.push({
                    campo: key,
                    valorAnterior: sobrescricao[key],
                    valorAtual: atualizacao[key],
                });
            }
        }

        setModificacoesRealizadas(modificacoesFeitas);
    };

    const downloadExcel = async () => {
        try {
            const response = await api.get('/log-att-cadastral'); // Usa a instância do Axios com o token já configurado
            const data = response.data; // Obtém os dados
    
            // Converte os dados para um formato Excel
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Atualizações');
    
            // Formata a data e hora atual
            const now = new Date();
            const formattedDate = now.toLocaleString('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replace(/\//g, '-').replace(',', ''); // Substitui / por - e remove a vírgula
    
            const fileName = `Atualizacao—${formattedDate}.xlsx`; // Define o nome do arquivo
    
            // Faz o download do arquivo Excel
            XLSX.writeFile(workbook, fileName);
        } catch (error) {
            alert('Erro ao baixar as modificações: ' + error.message);
        }
    };
    
    

    return (
        <div>
            <h1>Atualizações Cadastrais</h1>
            <button onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>LOGUSER</th>
                        <th>AÇÃO</th>
                        <th>CODCAMPUS</th>
                        <th>DESCRICAO</th>
                        <th>ATIVO</th>
                        <th>CAMPUSMEC</th>
                        <th>RUA</th>
                        <th>NUMERO</th>
                        <th>COMPLEMENTO</th>
                        <th>BAIRRO</th>
                        <th>CIDADE</th>
                        <th>CEP</th>
                        <th>UF</th>
                        <th>AREATOTAL</th>
                        <th>AREAVERDE</th>
                        <th>AREACONSTRUIDA</th>
                        <th>AREACONSTRUIR</th>
                        <th>AREAESTACIONAMENTO</th>
                        <th>VAGASESTDEFICIENTES</th>
                        <th>CRIADO POR</th>
                        <th>CRIADO EM</th>
                        <th>ATUALIZADO POR</th>
                        <th>ATUALIZADO EM</th>
                    </tr>
                </thead>
                <tbody>
                    {modificacoes.map((modificacao, index) => (
                        <tr key={index}>
                            <td>{modificacao['LOGUSER']}</td>
                            <td>{modificacao['AÇÃO']}</td>
                            <td>{modificacao['CODCAMPUS']}</td>
                            <td>{modificacao['DESCRICAO']}</td>
                            <td>{modificacao['ATIVO']}</td>
                            <td>{modificacao['CAMPUSMEC']}</td>
                            <td>{modificacao['RUA']}</td>
                            <td>{modificacao['NUMERO']}</td>
                            <td>{modificacao['COMPLEMENTO']}</td>
                            <td>{modificacao['BAIRRO']}</td>
                            <td>{modificacao['CIDADE']}</td>
                            <td>{modificacao['CEP']}</td>
                            <td>{modificacao['UF']}</td>
                            <td>{modificacao['AREATOTAL']}</td>
                            <td>{modificacao['AREAVERDE']}</td>
                            <td>{modificacao['AREACONSTRUIDA']}</td>
                            <td>{modificacao['AREACONSTRUIR']}</td>
                            <td>{modificacao['AREAESTACIONAMENTO']}</td>
                            <td>{modificacao['VAGASESTDEFICIENTES']}</td>
                            <td>{modificacao['CRIADO POR']}</td>
                            <td>{modificacao['CRIADO EM']}</td>
                            <td>{modificacao['ATUALIZADO POR']}</td>
                            <td>{modificacao['ATUALIZADO EM']}</td>
                        </tr>
                    ))}
                </tbody>
                <br />
                <thead>
                    <tr>
                        <th>MODIFICAÇÕES REALIZADAS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {modificacoesRealizadas.map((modificacao, index) => (
                            <td key={index}>
                                <strong>{modificacao.campo}: </strong>
                                {modificacao.valorAnterior} → {modificacao.valorAtual}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default AttCadastral;
